module.exports = __webpack_public_path__ + "img/2023big25.c1589634.png";